(function () {
  const root = document.querySelector('[data-happy-board]');
  if (!root) return;
  const film = root.querySelector('[data-happy-video]');
  const feature = root.querySelector('[data-video-endpoint]');
  const soundButton = root.querySelector('[data-happy-sound]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let inView = false, manuallyPaused = false, selected = 0, videos = [];
  film.muted = true;
  function updatePlayback() {
    if (inView && !document.hidden && !reducedMotion.matches && !manuallyPaused && film.currentSrc) film.play().catch(() => {});
    else film.pause();
  }
  new IntersectionObserver(entries => {inView = entries[0].isIntersecting; updatePlayback();}, {threshold:0.25}).observe(film);
  document.addEventListener('visibilitychange', updatePlayback);
  reducedMotion.addEventListener('change', updatePlayback);
  film.addEventListener('pause', () => {if (inView && !document.hidden && !film.ended) manuallyPaused = true;});
  film.addEventListener('play', () => {manuallyPaused = false;});
  film.addEventListener('volumechange', () => {
    soundButton.setAttribute('aria-pressed', String(!film.muted));
    soundButton.textContent = film.muted ? 'Sound off ♪' : 'Sound on ♪';
  });
  soundButton.addEventListener('click', () => {film.muted = !film.muted;});
  const notes = root.querySelector('.hj-happy-film-notes');
  const pauseButton = root.querySelector('[data-video-pause]');
  pauseButton.addEventListener('click', () => {
    if (film.paused) {manuallyPaused = false; film.play().catch(() => {});}
    else {manuallyPaused = true; film.pause();}
  });
  function syncPause() {
    pauseButton.textContent = film.paused ? '▶' : 'Ⅱ';
    pauseButton.setAttribute('aria-label', film.paused ? 'Play video' : 'Pause video');
  }
  film.addEventListener('pause', syncPause);
  film.addEventListener('play', syncPause);
  let quotes = {};
  const quoteWrap = root.querySelector('[data-video-quote-wrap]');
  const quoteText = root.querySelector('[data-video-quote]');
  const quoteToggle = root.querySelector('[data-video-quote-toggle]');
  function showQuote() {
    const matched = quotes[videos[selected]?.id];
    const productLink = root.querySelector('[data-video-caption]');
    if (matched?.productUrl?.startsWith('/products/')) productLink.setAttribute('href', matched.productUrl);
    else if (videos[selected]?.id) productLink.setAttribute('href', 'https://loox.io/p/' + encodeURIComponent(videos[selected].id));
    else productLink.removeAttribute('href');
    const body = matched?.body || '';
    quoteText.textContent = body;
    quoteWrap.hidden = !body;
    quoteWrap.classList.remove('is-expanded');
    quoteToggle.hidden = body.length < 120;
    quoteToggle.textContent = 'Read more';
    quoteToggle.setAttribute('aria-expanded','false');
  }
  quoteToggle.addEventListener('click', () => {
    const expanded = quoteWrap.classList.toggle('is-expanded');
    quoteToggle.setAttribute('aria-expanded',String(expanded));
    quoteToggle.textContent = expanded ? 'Read less' : 'Read more';
    if (expanded) {manuallyPaused = true; film.pause();}
  });
  fetch(feature.dataset.quoteLibrary).then(r => {if (!r.ok) throw new Error('Unavailable'); return r.json();}).then(data => {Object.entries(data.reviews).forEach(([id,review]) => {quotes[id] = {...review,...quotes[id]};}); showQuote();}).catch(() => {});
  const carousel = root.querySelector('[data-video-carousel]');
  const filmFrame = film.parentElement;
  let slides = [], scrollTimer, programmatic = false;
  function centerSlide(slide, behavior = 'smooth') {
    carousel.scrollTo({left:slide.offsetLeft - (carousel.clientWidth - slide.offsetWidth) / 2, behavior});
  }
  function selectVideo(index, scroll = true) {
    selected = (index + videos.length) % videos.length;
    index = selected;
    const active = slides[index + 2];
    slides.forEach((slide, position) => {
      const current = slide === active;
      slide.classList.toggle('is-active', current);
      slide.classList.toggle('is-near', Math.abs(position - index - 2) === 1);
      slide.querySelector('button').hidden = current;
    });
    active.append(filmFrame);
    if (scroll) {
      programmatic = true;
      centerSlide(active);
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {programmatic = false;}, 650);
    }
    if (!scroll) centerSlide(active, 'instant');
    showQuote();
    const review = videos[index];
    manuallyPaused = false;
    film.poster = new URL(review.poster, 'https://images.loox.io').href;
    film.src = review.preview;
    film.setAttribute('aria-label', `Video review by ${review.reviewer}`);
    root.querySelector('[data-video-name]').textContent = review.reviewer;
    const stars = root.querySelector('[data-video-stars]');
    stars.textContent = '★'.repeat(review.rating);
    stars.setAttribute('aria-label', `${review.rating} out of 5 stars`);
    root.querySelector('[data-video-caption]').textContent = (review.altText || '').replace(/^Customer video review of /i, '');

    film.addEventListener('loadeddata', () => {manuallyPaused = false; updatePlayback();}, {once:true});
  }
  film.addEventListener('ended', () => {if (videos.length && inView && !document.hidden && !reducedMotion.matches) selectVideo((selected + 1) % videos.length);});
  async function loadVideos() {
    try {
      const response = await fetch(feature.dataset.videoEndpoint, {signal:AbortSignal.timeout(12000)});
      if (!response.ok) throw new Error('Unavailable');
      const data = await response.json();
      videos = data.reviews.filter(review => {
        try {return /^[\w-]+$/.test(review.id) && review.reviewer && review.rating >= 1 && review.rating <= 5 && Number.isInteger(review.rating) && new URL(review.preview).hostname === 'images.loox.io' && new URL(review.preview).protocol === 'https:' && new URL(review.poster,'https://images.loox.io').hostname === 'images.loox.io';} catch {return false;}
      });
      if (!videos.length) throw new Error('No videos');
      [videos.length - 2, videos.length - 1, ...videos.map((_,index) => index), 0, 1].forEach(index => {
        const review = videos[index];
        const slide = document.createElement('div'); slide.className = 'hj-happy-slide'; slide.dataset.videoIndex = index;
        const button = document.createElement('button'); button.type = 'button';
        button.setAttribute('aria-label', `Watch ${review.reviewer}’s video`);
        const image = document.createElement('img'); image.src = new URL(review.poster,'https://images.loox.io').href; image.alt = ''; image.loading = 'lazy';
        button.append(image); button.addEventListener('click', () => selectVideo(index)); slide.append(button);
        const identity = document.createElement('div'); identity.className = 'hj-happy-slide-identity';
        const name = document.createElement('span'); name.textContent = review.reviewer;
        const stars = document.createElement('span'); stars.textContent = '★'.repeat(review.rating); stars.setAttribute('aria-label', `${review.rating} out of 5 stars`);
        identity.append(name, stars); slide.append(identity);
        carousel.append(slide); slides.push(slide);
      });
      selectVideo(0);
    } catch {root.querySelector('[data-video-caption]').textContent='Customer videos are available in the reviews below.'; feature.classList.add('is-unavailable');}
  }
  carousel.addEventListener('scroll', () => {
    if (programmatic || !slides.length) return;
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
      const center = carousel.scrollLeft + carousel.clientWidth / 2;
      const nearest = slides.reduce((best, slide) => Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - center) < Math.abs(best.offsetLeft + best.offsetWidth / 2 - center) ? slide : best);
      const index = Number(nearest.dataset.videoIndex);
      if (index !== selected) selectVideo(index, false);
      if (slides.indexOf(nearest) < 2 || slides.indexOf(nearest) >= slides.length - 2) centerSlide(slides[index + 2], 'instant');
    }, 140);
  }, {passive:true});
  carousel.addEventListener('keydown', event => {
    if (event.target !== carousel || !videos.length) return;
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault(); selectVideo(selected + (event.key === 'ArrowRight' ? 1 : -1));
    }
  });
  new ResizeObserver(() => {if (slides.length) centerSlide(slides[selected + 2], 'instant');}).observe(carousel);
  loadVideos();
  const status = root.querySelector('[data-happy-status]');
  root.addEventListener('click', event => {
    const link = event.target.closest('[data-review-id]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (typeof window.LOOX?.openQV === 'function') {event.preventDefault(); window.LOOX.openQV(link.dataset.reviewId);}
  });
  async function load() {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 12000);
    try {
      const sources = [root.dataset.source, root.dataset.extraSource].filter(Boolean);
      const requests = sources.map(async source => {
        const response = await fetch(source, {signal:controller.signal});
        if (!response.ok) throw new Error('Unavailable');
        const sample = window.HJReviewData.parseReviews(new DOMParser().parseFromString(await response.text(),'text/html'), location.origin);
        sample.filter(r => r.video).forEach(r => {quotes[r.id] = {...quotes[r.id],body:r.body,name:r.name};});
        showQuote();
        return sample.filter(r => !r.video);
      });
      requests.push(fetch(root.dataset.photoLibrary, {signal:controller.signal}).then(response => {if (!response.ok) throw new Error('Unavailable'); return response.json();}).then(data => data.reviews));
      const results = await Promise.allSettled(requests);
      const groups = results.filter(r => r.status === 'fulfilled').map(r => r.value);
      const reviews = [], seen = new Set();
      for (let index = 0; index < Math.max(0, ...groups.map(g => g.length)) && reviews.length < 12; index++) {
        groups.forEach(group => {const review = group[index]; if (review && !seen.has(review.id) && reviews.length < 12) {seen.add(review.id); reviews.push(review);}});
      }
      if (!reviews.length) throw new Error('No photos');
      const board = root.querySelector('[data-happy-photos]');
      reviews.forEach(review => {
        const card = document.createElement('a'); card.className = 'hj-happy-card'; card.dataset.reviewId = review.id;
        card.href = window.HJReviewData.reviewURL(review.id, location.href);
        const photo = document.createElement('img'); photo.src = review.image; photo.alt = `Customer photo from ${review.name}`; photo.loading = 'lazy';
        const stars = document.createElement('span'); stars.className = 'hj-happy-stars'; stars.textContent = '★'.repeat(review.rating); stars.setAttribute('aria-label',`${review.rating} out of 5 stars`);
        const quote = document.createElement('blockquote'); quote.textContent = review.body;
        const name = document.createElement('strong'); name.textContent = review.name;
        card.append(photo,stars,quote,name);
        board.append(card);
      });
      status.hidden = true;
    } catch {status.textContent='Explore all customer photos and stories below.';}
    finally {clearTimeout(timer);}
  }
  load();
}());
